function InfoSection() {
  return (
    <section className="info-section">
      <div className="info-card">
        <div className="why-torque">
          <h2>WHY TORQUE?</h2>
          <h3>MAXIMUM PERFORMANCE. MAXIMUM YOU.</h3>
          <p>Designed for ages 14-45. Fuel your sports, studies, and workdays.</p>
          <div className="features">
            <div className="feature-item"><i className="fas fa-bolt"></i><span>Boosts Energy</span></div>
            <div className="feature-item"><i className="fas fa-brain"></i><span>Sharpens Focus</span></div>
            <div className="feature-item"><i className="fas fa-book-open"></i><span>Sustains studies</span></div>
            <div className="feature-item"><i className="fas fa-person-running"></i><span>Sustains Activity</span></div>
            <div className="feature-item"><i className="fas fa-briefcase"></i><span>Workout and workdays</span></div>
          </div>
        </div>
        <div className="nutrition-facts">
          <h4>NUTRITION FACTS</h4>
          <div className="nutrient">
            <label>ENERGY</label><span>61.98 Kcal</span>
            <div className="bar-bg"><div className="bar-fill" style={{ width: '3.87%' }}></div></div>
          </div>
          <div className="nutrient">
            <label>CARBS</label><span>15.49g</span>
            <div className="bar-bg"><div className="bar-fill" style={{ width: '5%' }}></div></div>
          </div>
          <div className="nutrient">
            <label>SUGAR</label><span>15.33g</span>
            <div className="bar-bg"><div className="bar-fill" style={{ width: '34.7%' }}></div></div>
          </div>
          <div className="nutrient">
            <label>SODIUM</label><span>109.34mg</span>
            <div className="bar-bg"><div className="bar-fill" style={{ width: '6.83%' }}></div></div>
          </div>
          <div className="nutrient-note">
            <small>Per 100ml • Contains Caffeine</small>
          </div>
        </div>
      </div>
    </section>
  );
}

export default InfoSection;